import React from "react";
import { Link } from "react-router-dom";
import { getNewsList } from "../../data/news";

const news = getNewsList().slice(0, 3);

const CampusNews = () => {
  return (
    <section className="bg-gray-100 py-8 sm:py-12 md:py-16 px-4 sm:px-6 md:px-8 text-center">
      {/* News Container */}
      <div className="container mx-auto p-4 sm:p-6 md:p-8 rounded-lg">
        <h2 className="text-2xl sm:text-3xl font-bold text-left text-custom-pink mb-6 sm:mb-8">
          Latest News
        </h2>

        {/* News Cards */}
        <div className="flex flex-col sm:flex-row flex-wrap sm:flex-nowrap gap-6 sm:gap-8">
          {news.map((newsItem, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden w-full sm:w-[calc(50%-1rem)] md:w-[calc(33.333%-1rem)] relative flex flex-col"
            >
              {/* News Image */}
              <div className="relative">
                <img
                  src={newsItem.image}
                  alt={newsItem.title}
                  className="w-full h-[200px] sm:h-[240px] md:h-[270px] object-cover"
                />
                <span className="block border-b-4 border-gold w-full"></span>
              </div>

              {/* News Content */}
              <div className="flex-grow p-4 sm:p-6 md:p-8 flex text-left flex-col justify-between">
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-black mb-3 sm:mb-4">
                    {newsItem.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                    {newsItem.description}
                  </p>
                </div>

                {/* Read More Button */}
                <Link
                  to={`/news/${newsItem.id}`}
                  className="bg-custom-pink py-3 sm:py-4 px-6 sm:px-8 rounded-full text-white text-sm sm:text-base border border-transparent hover:bg-transparent hover:text-custom-pink hover:border-custom-pink transition duration-300 self-start inline-block"
                >
                  READ MORE
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/*     <span className="block border-dotted border-l-4 border-gold mb-4 mt-20 w-28 h-24 mx-auto md:ml-auto md:mr-0 lg:ml-[925px] bg-gray-100"></span>*/}
    </section>
  );
};

export default CampusNews;
